import { ActionCreatorWithPayload, createSelector, EntitySelectors, Update } from '@reduxjs/toolkit';

export const bindOptionUpdaterFactory = (
    updateOptions: ActionCreatorWithPayload<Update<any>>
) => {
    return ({
        to: <TOptions>() => {
            return <K extends keyof TOptions>(key: K) => {
                return (id: string, value: TOptions[K]) => {
                    return updateOptions({ id, changes: { [key]: value } });
                };
            };
        }
    });
};

export const bindOptionSelectorFactory = <TState, TEntity extends { options: any }>(
    selectors: EntitySelectors<TEntity, TState>
) => {
    return ({
        to: <TOptions>() => {
            return <T>(selector: (o: TOptions) => T) => {
                return createSelector(selectors.selectById, v => v !== undefined
                    ? selector(v.options)
                    : undefined);
            };
        }
    });
};